import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import styles from "components/common/unknown-error-message.scss";

export const UnknownErrorMessage = ({ accountSlug, isGlobalError, onEndGlobalError }) => {
  const isErrorSpecific = !isGlobalError;
  if (isErrorSpecific) {
    return null;
  }
  return (
    <div className={ styles.container }>
      <div className={ styles.inner }>
        <span className={ styles.close } onClick={ onEndGlobalError }>+</span>
        <h2>Oh no... an error has occurred</h2>
        <div className={ styles["five-hundred"] }>500</div>
        <p>
          Please try <a href="/">reloading the page</a> in a few moments.
          </p>
        <p>
          Please <Link to={ `/accounts/${accountSlug}/issue-tracking-form` }>
          report this issue
          </Link>
          &nbsp;and/or contact us at &nbsp;<a href="mailto:help@squirrelstreet.com">help@squirrelstreet.com</a>
        </p>
      </div>
    </div>
  );
};

UnknownErrorMessage.propTypes = {
  accountSlug: PropTypes.string.isRequired,
  isGlobalError: PropTypes.bool.isRequired,
  onEndGlobalError: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/common/unknown-error-message.jsx